import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { getContainerNameAndMark, getContainerList, changeContainerStatus } from './request.js';
export default {
  data() {
    return {
      form: {},
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'id',
        key: '1',
        align: 'center',
        width: 80
      }, {
        slots: {
          title: '容器名称'
        },
        dataIndex: 'name',
        key: '2',
        align: 'center',
        ellipsis: true
      }, {
        slots: {
          title: '容器标识'
        },
        dataIndex: 'mark',
        key: '3',
        align: 'center',
        ellipsis: true
      }, {
        slots: {
          title: '容器分类'
        },
        dataIndex: 'type',
        key: '4',
        align: 'center',
        ellipsis: true,
        scopedSlots: {
          customRender: 'type'
        }
      }, {
        slots: {
          title: '状态'
        },
        dataIndex: 'status',
        key: '5',
        align: 'center',
        ellipsis: true,
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        slots: {
          title: '更新时间'
        },
        dataIndex: 'updateAt',
        key: '6',
        align: 'center',
        ellipsis: true
      }, {
        slots: {
          title: '操作'
        },
        key: '7',
        align: 'center',
        width: 230,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      data: [],
      functionMarkList: [],
      nameOptions: [],
      markOptions: [],
      visible: false,
      fileTemplateInfo: [],
      customerInfo: [],
      containerVisible: false,
      containerForm: {
        id: -1,
        rowNum: 1,
        tableHeaderRowNum: 1,
        columnNum: 3,
        type: 'table',
        tableType: 'increment',
        tableUsage: 'template'
      }
    };
  },
  created() {
    getContainerNameAndMark({}).then(res => {
      this.functionMarkList = res;
      if (res) {
        this.nameOptions = res.name;
        this.markOptions = res.mark;
      }
    });
    this.getContainerTable();
  },
  computed: {
    containerRules() {
      return {
        columnNum: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value < 3 || value > 9) {
              callback(new Error(this.$t('列输入无效,请重新输入')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        rowNum: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value < 1 || value > 50) {
              callback(new Error(this.$t('行输入无效,请重新输入')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }]
      };
    },
    maxTabHeaderNum() {
      if (this.containerForm.tableType === 'increment') {
        return 100;
      } else if (this.containerForm.tableType === 'fixed') {
        return this.containerForm.rowNum - 1;
      } else {
        return 100;
      }
    }
  },
  watch: {
    'containerForm.tableType': {
      handler(val) {
        if (val) {
          this.containerForm.rowNum = val === 'increment' ? 1 : 2;
        }
      }
    }
  },
  methods: {
    newContainerOk() {
      this.$refs['containerForm'].validate(valid => {
        if (valid) {
          sessionStorage.setItem('templateTableInitInfo', JSON.stringify(this.containerForm));
          this.$router.push({
            name: 'containerTemplateTableDesign',
            params: {
              id: -1,
              type: this.containerForm.tableUsage,
              columnNum: this.containerForm.columnNum
            }
          });
        }
      });
    },
    newContainer() {
      this.$refs.containerForm && this.$refs.containerForm.resetFields();
      this.containerVisible = true;
    },
    searchContainer() {
      this.pagination.current = 1;
      this.pagination.pageSize = 10;
      this.getContainerTable();
    },
    getContainerTable() {
      let params = {
        mark: this.form.mark || '',
        name: this.form.name || '',
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      };
      getContainerList(params).then(res => {
        if (res && res.items) {
          this.pagination.total = res.totalNum;
          this.data = res.items;
        }
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getContainerTable();
    },
    seeFunction() {},
    changeStatus(record) {
      let params = {
        id: record.id,
        status: record.status === 1 ? 0 : 1
      };
      this.quetoFileList = [];
      changeContainerStatus(params).then(res => {
        if (!res.id) {
          this.visible = true;
          this.fileTemplateInfo = res.fileTemplateInfo;
          this.customerInfo = res.customerInfo;
        } else {
          this.$message.destroy();
          this.$message.success(this.$t('修改成功'));
          this.data.forEach(item => {
            if (item.id === record.id) {
              item.status = item.status === 1 ? 0 : 1;
            }
          });
        }
      });
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    changeTableType(key) {
      this.containerForm.tableType = key;
    },
    editTemplate(record) {
      this.$router.push({
        name: 'containerTemplateTableDesign',
        params: {
          id: record.id,
          type: 'table',
          columnNum: 3
        }
      });
      let obj = {
        id: record.id,
        type: 'table',
        tableType: 'increment',
        tableUsage: 'template'
      };
      sessionStorage.setItem('tableInitInfo', JSON.stringify(obj));
    }
  }
};